export default __webpack_public_path__ + "static/mkr-ae823db1b085999fc7a330eaf37e010a.png";